import { GamesCardListSkeleton } from "@/components/webview/games/core/GamesCardListSkeleton";
import { useTrans } from "@/utils/useTrans";
import { LayoutGamesWebView } from "@/components/webview/games/layout/LayoutGamesWebView";
import dynamic from "next/dynamic";
import Link from "next/link";
import { WEBVIEW_ROUTES } from "@/components/webview/route";
import { Button1 } from "@/components/webview/games/typograpy/typograpy-webview";
import { GamesPlatformWebView } from "@/components/webview/games/constants/gameResellWebViewConstants";

const LazyCompatibleVrHeadsetsBodyWebView = dynamic<{ className?: string }>(
  () => import("../GamesVRHeadsetsSectionWebView"),
  {
    ssr: false,
  },
);

const LazyGamesNewGamesWebView = dynamic<{
  className?: string;
  platform?: GamesPlatformWebView;
}>(() => import("../GamesNewGamesWebView"), {
  ssr: false,
  loading: () => (
    <LayoutGamesWebView
      className={"py-4"}
      header={<h2 className="px-4">{"New Games"}</h2>}
      contents={
        <GamesCardListSkeleton
          cardCount={9}
          className={"bg-[#1C1C1C]"}
          cardWidth={"w-[100px]"}
        />
      }
    />
  ),
});

const LazyGamesGameKeySalesWebView = dynamic<{
  platform?: GamesPlatformWebView;
}>(() => import("../GamesGameKeySalesWebView"), {
  ssr: false,
  loading: () => (
    <LayoutGamesWebView
      className="bg-black py-4"
      header={<h2 className="px-4">{"Game Key Sales"}</h2>}
      contents={<GamesCardListSkeleton />}
    />
  ),
});

const PLATFORM = GamesPlatformWebView.Quest;

const MetaQuestLazySectionsWebView = () => {
  const { t } = useTrans(["games"]);
  return (
    <div className="flex flex-col gap-[38px] bg-black">
      <LazyCompatibleVrHeadsetsBodyWebView />
      <LazyGamesNewGamesWebView platform={PLATFORM} />
      <LazyGamesGameKeySalesWebView platform={PLATFORM} />
      <LayoutGamesWebView
        className="px-4 pb-10"
        contents={
          <Link
            href={`${WEBVIEW_ROUTES.webviewSearch}/?filter=${GamesPlatformWebView.Quest}&sort=monthlyPlayCount&only-sellable=false`}
            className="flex h-[50px] w-full items-center justify-center rounded-md bg-[#FFD900] text-black"
          >
            <Button1>{t("See All Meta Quest Games")}</Button1>
          </Link>
        }
      />
    </div>
  );
};

export default MetaQuestLazySectionsWebView;
